import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chipDefaultVariants = {
  "size": "md",
  "color": "neutral"
}
const chipCompoundVariants = [
  {
    "type": "fill",
    "css": {
      "root": {
        "color": "chip.fill.fg.default"
      },
      "icon": {
        "color": "inherit"
      },
      "label": {
        "color": "inherit"
      }
    }
  },
  {
    "color": "brand",
    "type": "fill",
    "css": {
      "root": {
        "backgroundColor": "chip.fill.bg.brand"
      }
    }
  },
  {
    "color": "neutral",
    "type": "fill",
    "css": {
      "root": {
        "backgroundColor": "chip.fill.bg.neutral"
      }
    }
  },
  {
    "color": "green",
    "type": "fill",
    "css": {
      "root": {
        "backgroundColor": "chip.fill.bg.green"
      }
    }
  },
  {
    "color": "orange",
    "type": "fill",
    "css": {
      "root": {
        "backgroundColor": "chip.fill.bg.orange",
        "color": "chip.fill.fg.orange"
      }
    }
  },
  {
    "color": "blue",
    "type": "fill",
    "css": {
      "root": {
        "backgroundColor": "chip.fill.bg.blue"
      }
    }
  },
  {
    "color": "red",
    "type": "fill",
    "css": {
      "root": {
        "backgroundColor": "chip.fill.bg.red"
      }
    }
  },
  {
    "color": "brand",
    "type": "fill",
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.lighten.hover"
          }
        }
      }
    }
  },
  {
    "color": "brand",
    "type": [
      "text",
      "outlined",
      "transparent"
    ],
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.darken.hover"
          }
        }
      }
    }
  },
  {
    "color": "neutral",
    "type": "fill",
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.lighten.hover"
          }
        }
      }
    }
  },
  {
    "color": "neutral",
    "type": [
      "text",
      "outlined",
      "transparent"
    ],
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.darken.hover"
          }
        }
      }
    }
  },
  {
    "color": "green",
    "type": "fill",
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.lighten.hover"
          }
        }
      }
    }
  },
  {
    "color": "green",
    "type": [
      "text",
      "outlined",
      "transparent"
    ],
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.darken.hover"
          }
        }
      }
    }
  },
  {
    "color": "orange",
    "type": "fill",
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.lighten.hover"
          }
        }
      }
    }
  },
  {
    "color": "orange",
    "type": [
      "text",
      "outlined",
      "transparent"
    ],
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.darken.hover"
          }
        }
      }
    }
  },
  {
    "color": "blue",
    "type": "fill",
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.lighten.hover"
          }
        }
      }
    }
  },
  {
    "color": "blue",
    "type": [
      "text",
      "outlined",
      "transparent"
    ],
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.darken.hover"
          }
        }
      }
    }
  },
  {
    "color": "red",
    "type": "fill",
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.lighten.hover"
          }
        }
      }
    }
  },
  {
    "color": "red",
    "type": [
      "text",
      "outlined",
      "transparent"
    ],
    "clickable": true,
    "css": {
      "root": {
        "_hover": {
          "_before": {
            "backgroundColor": "overlay.darken.hover"
          }
        }
      }
    }
  },
  {
    "color": "brand",
    "type": "outlined",
    "css": {
      "root": {
        "backgroundColor": "chip.outlined.bg.brand",
        "borderColor": "chip.outlined.border.brand",
        "color": "chip.outlined.text.brand"
      },
      "icon": {
        "color": "chip.outlined.fg.brand"
      }
    }
  },
  {
    "color": "neutral",
    "type": "outlined",
    "css": {
      "root": {
        "backgroundColor": "chip.outlined.bg.neutral",
        "borderColor": "chip.outlined.border.neutral",
        "color": "chip.outlined.text.neutral"
      },
      "icon": {
        "color": "chip.outlined.fg.neutral"
      }
    }
  },
  {
    "color": "green",
    "type": "outlined",
    "css": {
      "root": {
        "backgroundColor": "chip.outlined.bg.green",
        "borderColor": "chip.outlined.border.green",
        "color": "chip.outlined.text.green"
      },
      "icon": {
        "color": "chip.outlined.fg.green"
      }
    }
  },
  {
    "color": "orange",
    "type": "outlined",
    "css": {
      "root": {
        "backgroundColor": "chip.outlined.bg.orange",
        "borderColor": "chip.outlined.border.orange",
        "color": "chip.outlined.text.orange"
      },
      "icon": {
        "color": "chip.outlined.fg.orange"
      }
    }
  },
  {
    "color": "blue",
    "type": "outlined",
    "css": {
      "root": {
        "backgroundColor": "chip.outlined.bg.blue",
        "borderColor": "chip.outlined.border.blue",
        "color": "chip.outlined.text.blue"
      },
      "icon": {
        "color": "chip.outlined.fg.blue"
      }
    }
  },
  {
    "color": "red",
    "type": "outlined",
    "css": {
      "root": {
        "backgroundColor": "chip.outlined.bg.red",
        "borderColor": "chip.outlined.border.red",
        "color": "chip.outlined.text.red"
      },
      "icon": {
        "color": "chip.outlined.fg.red"
      }
    }
  },
  {
    "color": "brand",
    "type": "text",
    "css": {
      "root": {
        "backgroundColor": "chip.text.bg.brand",
        "color": "chip.text.text.brand"
      },
      "icon": {
        "color": "chip.text.fg.brand"
      }
    }
  },
  {
    "color": "neutral",
    "type": "text",
    "css": {
      "root": {
        "backgroundColor": "chip.text.bg.neutral",
        "color": "chip.text.text.neutral"
      },
      "icon": {
        "color": "chip.text.fg.neutral"
      }
    }
  },
  {
    "color": "green",
    "type": "text",
    "css": {
      "root": {
        "backgroundColor": "chip.text.bg.green",
        "color": "chip.text.text.green"
      },
      "icon": {
        "color": "chip.text.fg.green"
      }
    }
  },
  {
    "color": "orange",
    "type": "text",
    "css": {
      "root": {
        "backgroundColor": "chip.text.bg.orange",
        "color": "chip.text.text.orange"
      },
      "icon": {
        "color": "chip.text.fg.orange"
      }
    }
  },
  {
    "color": "blue",
    "type": "text",
    "css": {
      "root": {
        "backgroundColor": "chip.text.bg.blue",
        "color": "chip.text.text.blue"
      },
      "icon": {
        "color": "chip.text.fg.blue"
      }
    }
  },
  {
    "color": "red",
    "type": "text",
    "css": {
      "root": {
        "backgroundColor": "chip.text.bg.red",
        "color": "chip.text.text.red"
      },
      "icon": {
        "color": "chip.text.fg.red"
      }
    }
  }
]

const chipSlotNames = [
  [
    "root",
    "chip__root"
  ],
  [
    "label",
    "chip__label"
  ],
  [
    "icon",
    "chip__icon"
  ],
  [
    "delete",
    "chip__delete"
  ]
]
const chipSlotFns = /* @__PURE__ */ chipSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chipDefaultVariants, getSlotCompoundVariant(chipCompoundVariants, slotName))])

const chipFn = memo((props = {}) => {
  return Object.fromEntries(chipSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chipVariantKeys = [
  "clickable",
  "size",
  "color",
  "multiline",
  "type"
]
const getVariantProps = (variants) => ({ ...chipDefaultVariants, ...compact(variants) })

export const chip = /* @__PURE__ */ Object.assign(chipFn, {
  __recipe__: false,
  __name__: 'chip',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chipVariantKeys,
  variantMap: {
  "clickable": [
    "true"
  ],
  "size": [
    "xs",
    "sm",
    "md",
    "lg"
  ],
  "color": [
    "brand",
    "neutral",
    "green",
    "orange",
    "blue",
    "red"
  ],
  "multiline": [
    "true"
  ],
  "type": [
    "fill",
    "outlined",
    "text",
    "transparent"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, chipVariantKeys)
  },
  getVariantProps
})